/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const BackupApiEnum = {
    GET_BACKUPS_ALL: (namespace: string): string => {
        return `/${namespace}/backups/`;
    },
    GET_BACKUP: (namespace: string, backupId: string): string => {
        return `/${namespace}/backups/${backupId}/download`;
    },
    POST_BACKUP: (namespace: string, adcId: string): string => {
        return `/${namespace}/adcs/${adcId}/backup`;
    },
    DELETE_BACKUP: (namespace: string, backupId: string): string => {
        return `/${namespace}/backups/${backupId}`;
    }
};

